<script setup lang="ts">
import AiGeneratedBadge from '../shared/AiGeneratedBadge.vue'

defineProps<{
  showOwnerBrand: boolean,
  showAdBadge: boolean,
  imageIsAiGenerated: boolean,
  isAffiliate?: boolean,
  brandBadgeAlt: string,
  brandBadgeSrc: (type: string) => string
}>()
</script>

<template>
  <div v-if="showAdBadge || showOwnerBrand || imageIsAiGenerated"
       class="bx-badges bx-badges--top bx-badges--over-image">
    <span v-if="showOwnerBrand"
          class="bx-badge bx-badge--brand">
      <img :src="brandBadgeSrc('icon')"
           :alt="`${brandBadgeAlt} Icon`"
           class="bx-badge--brand__icon">
      <img :src="brandBadgeSrc('logo')"
           :alt="`${brandBadgeAlt} Logo`"
           class="bx-badge--brand__logo">
    </span>
    <AiGeneratedBadge v-if="imageIsAiGenerated" />
    <span v-if="showAdBadge"
          class="bx-badge bx-badge--ad"
          :class="{ 'bx-badge--affiliate-link': isAffiliate }" />
  </div>
</template>
